define('views/base/baseCompositeView',[
    'marionette',
    'underscore'
], function (Marionette, _) {
    'use strict';
    return Marionette.CompositeView.extend(_.extend({}));
});
